module.exports = __webpack_public_path__ + "img/sample-scienceTeacher.7f79864e.webp";